'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useState } from 'react';

import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import Portal from 'components/ui/Portal';
import Text from 'components/ui/Text';
import UltraBoldHeading from 'components/ui/UltraBoldHeading';

import TalesOverlay from '../TalesOverlay';

import styles from './TheMorningStar.module.scss';

const image = {
    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/3IftKkrhOdqn1W9Lmpy2QS/c7f41d8929a5d781cdb1127ac614ca64/the-morning-star-m.png',
    width: 614,
    height: 512,
};

const imageLarge = {
    url: 'https://images.ctfassets.net/j8tkpy1gjhi5/Azb0PxASRfdeiosIP85TG/7895b36a2e97fdf2fa976f083c4c3421/the-morning-star-d.png',
    width: 1152,
    height: 1256,
};

const TheMorningStar = ({ overlay, customProperties }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleCtaClick = () => {
        setIsOpen(true);
    };

    const handleOverlayClose = () => {
        setIsOpen(false);
    };

    return (
        <section id="morning" className={styles.root}>
            <div className={styles.inner}>
                <div className={styles.content}>
                    <div className={styles.imageContainer}>
                        <Img
                            className={styles.image}
                            src={image.url}
                            width={image?.width}
                            height={image?.height}
                            alt="Morning Star in front of Tillamook building"
                            fallbackImageWidth={500}
                            customSources={[
                                {
                                    breakpoint: 1280,
                                    src: imageLarge.url,
                                    imageWidth: 1920,
                                },
                                {
                                    breakpoint: 768,
                                    src: imageLarge.url,
                                    imageWidth: 1280,
                                },
                                {
                                    src: image.url,
                                    imageWidth: 1280,
                                },
                            ]}
                        />
                    </div>
                    <div className={styles.lockup}>
                        <UltraBoldHeading
                            as="h2"
                            baseTheme={'displayMedium'}
                            themes={{
                                medium: 'displayMedium',
                                large: 'displayXLarge',
                            }}
                            icon={'morningStar'}
                            headline={{
                                json: {
                                    data: {},
                                    content: [
                                        {
                                            data: {},
                                            content: [
                                                {
                                                    data: {},
                                                    marks: [],
                                                    value: 'The\nMorning\nStar',
                                                    nodeType: 'text',
                                                },
                                            ],
                                            nodeType: 'paragraph',
                                        },
                                    ],
                                    nodeType: 'document',
                                },
                            }}
                        />
                        <Text
                            className={styles.copy}
                            baseTheme="bodyMedium"
                            themes={{ large: 'bodyLarge' }}
                        >
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: `Ever wonder why there’s a little boat on all our
                                            delicious dairy products? Well, that boat’s got a
                                            big story behind it. And without it, we might not be
                                            here today. This is the story behind the original
                                            <i>Morning Star.</i>`,
                                }}
                            />
                        </Text>
                        <ButtonCTA
                            className={styles.cta}
                            style="filled-cream-ocean"
                            text="Learn More"
                            onClick={handleCtaClick}
                            gtm-label="morning-star-section-overlay-cta"
                        />
                    </div>
                </div>
            </div>
            <Portal>
                <div style={customProperties}>
                    <TalesOverlay
                        isActive={isOpen}
                        content={overlay}
                        onClose={handleOverlayClose}
                    />
                </div>
            </Portal>
        </section>
    );
};

export default TheMorningStar;
